/**
 * Hook: Query lifecycle and refetch API for Invite Users page.
 * Single Responsibility: cleanup on unmount, expose refetch via onReady callback.
 */

import { useCallback, useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { USERS_QUERY_KEY } from '../../../hooks/useUsersInfinite';

export function useInviteUsersQuery() {
  const queryClient = useQueryClient();
  const refetchUsersRef = useRef(null);

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: USERS_QUERY_KEY });
    };
  }, [queryClient]);

  const refetchUsers = useCallback(async () => {
    await refetchUsersRef.current?.();
  }, []);

  const handleReady = useCallback((api) => {
    refetchUsersRef.current = api?.refetch ?? null;
  }, []);

  return {
    refetchUsers,
    handleReady,
  };
}
